<template>
  <p class="mb-8 text-left text-xl text-white bg-rose-800 p-4 rounded-lg border-rose-500 border-4">
    <p class="mb-2 leading-relaxed">
      Benvenuti sul nuovo portale Studi Musicali.
      <br/>
      Il sistema di accesso agli articoli del periodico - <span class="font-bold">riservato agli abbonati</span> - è cambiato. Non avverrà più attraverso
      gli indirizzi IP, ma sarà attivato chiedendo le credenziali alla seguente mail:
      <a href="mailto: studimusicali@santacecilia.it" class="underline">studimusicali@santacecilia.it</a>
    </p>
  </p>
</template>
